<template>
      <div class="addcommunity">
         <!-- <TheNavigationPanel/> -->
         <div class="mx-9">
         <v-container>
            <v-toolbar flat color="#F0FFEA" height="30">
                <v-toolbar-title style="color:#62AE32" class="headline">Add Community</v-toolbar-title>
            </v-toolbar>

            <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
                <span>You've successfully registered a new community.</span> 
                <v-btn text color="white" @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-snackbar v-model="snackbar2" :timeout="4000" top color="success">
                <span>Community Not Registered.</span> 
                <v-btn text color="white" @click="snackbar = false">Close</v-btn>
            </v-snackbar>
              <v-card class="ml-4 my-9" color="#F0FFEA" max-width="500" flat> 
                <v-form ref="form">
                <v-row no-gutters>
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                    <span style="font-size:13px; color:#615D5D">Community Name</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label="Adeleke Abiodun"
                            type="text"
                            solo
                            flat
                            dense
                            v-model="name"
                            class="black--text"
                            :rules="nameRules"
                        ></v-text-field>
                    </v-col>
                </v-row>
               

                <v-row no-gutters>
                    <v-col class="mt-2" cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Phone No</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label="08100000000"
                            type="tel"
                            solo
                            flat
                            dense
                            v-model="phone"
                            class="black--text"
                            :rules="phoneRules"
                        ></v-text-field>
                    </v-col>
                </v-row >
                <v-row no-gutters>
                    <v-col class="mt-2" cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Email</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label="jendel@gmail.com"
                            type="email"
                            solo
                            flat
                            dense
                            v-model="email"
                            class="black--text"
                            :rules="emailRules"
                        ></v-text-field>
                    </v-col>
                </v-row >
                <v-row no-gutters>
                    <v-col class="mt-2" cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Website</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            label="www.example.com"
                            type="website"
                            solo
                            flat
                            dense
                            v-model="website"
                            class="black--text"
                            :rules="websiteRules"
                        ></v-text-field>
                    </v-col>
                </v-row >
                <v-row no-gutters>
                    <v-col cols="12" md="4" sm="6" class="mt-2">
                        <span style="font-size:13px; color:#615D5D">Description</span>
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                        <v-textarea v-model="description" flat solo auto-grow="true" label="" :rules="descriptionRules"></v-textarea>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col class="mt-2" cols="12" md="4" sm="6">
                        <span style="font-size:13px; color:#615D5D">Address</span>
                        
                    </v-col>
                    <v-col cols="12" md="8" sm="6">
                          <v-textarea v-model="address" flat solo auto-grow="true" label="Adelaide close, Ibadan" :rules="addressRules"></v-textarea>
                    </v-col>
                </v-row >
                 <v-layout class="my-4">
                <v-spacer></v-spacer>
                <v-btn color="#08911b" :loading="loading" v-on:click="Add()" class="white--text font-weigth-bold " style="font-size:14px" large>
                    ADD COMMUNITY
                </v-btn>
                
            </v-layout>
            </v-form>
            </v-card>
         </v-container>
         </div> 
      </div>
</template>


<script>
// import TheNavigationPanel from '../components/TheNavigationPanel'
export default {
     components: {
        // TheNavigationPanel
    },
    data(){
        return{
            loading: false,
            name: '',
            phone: '',
            email: '',
            address: '',
            description: '',
            website: '',
            snackbar: false,
            snackbar2:false,
            nameRules:[v => !!v || 'Community name is required'],
            phoneRules:[v => !!v || 'Phone number is required',
                v => v.length <= 15 || 'Phonenumber must be less than 15 characters',
                v => {
                    const pattern = /^-?[0-9]+(.[0-9]{1-7})?$/;
                    // const pattern = /^(?:(?:01\d{9}|2\d{7}) ){1,}(?:01\d{9}|2\d{7})$/
                    return pattern.test(v) || 'Enter a valid number'
                } 
            ],
            emailRules:[v => !!v || 'Email is required',
                v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
            ],
            websiteRules:[v => !!v || 'Website is required'
                        
            ],
            descriptionRules:[v => !!v || 'Description is required'],
            addressRules:[v => !!v || 'Address is required'],
        }
    },
    methods:{
        Add(){
        if (this.$refs.form.validate()){
             this.loading = true
            this.$store.dispatch("addCommunity", {
                "communityName": this.name,
                "communityAddress": this.address,
                "communityEmail": this.email,
                "communityContactNumber": this.phone,
                "consultantUsername": this.$store.state.community.logindetails.consultant_id,
                "communityDescription": this.description,
                "communityWebsiteUrl": this.website
                })
            .then(()=>{
            this.loading = false
            this.name = '',
            this.address = '',
            this.phone = '',
            this.email = '',
            this.website = '',
            this.username = '',
            this.description = '',
            this.snackbar = true;
            })
            .catch(()=>{
                this.snackbar2 = true;
            });
        }
           
        }
    }
    
}
</script>


<style scoped>
.title-color{
  color : #62ae32;
}
.addcommunity{
    background-color: #f0ffea;
    height: 100%;
    background-size: cover;
}
</style>